import React from "react";
import { Modal } from "react-bootstrap";
import './ReplaceFileModal.scss'
import BulkDragAndDrop from "../../BulkUpload/BulkDragAndDrop/BulkDragAndDrop";

import closeIcon from "../../../assets/close.svg";

const ReplaceFileModal = ({handleOpenModal, handleCloseModal, handleDrop}) => {
  return (
    <Modal
      className="replace-modal"
      size="xl"
      centered
      show={handleOpenModal}
      onHide={handleCloseModal}
    >
      <div className="replace-modal-content">
        <div className="header">
          <h3 className="title">Replace Primary File</h3>
          <img className="close" src={closeIcon} alt="close" onClick={handleCloseModal} />
        </div>
        <div className="replace-modal-body">
          <div className="title bold">Primary File</div>
          <BulkDragAndDrop id="primary-file" handleDrop={handleDrop} />
          <div className="m-footer">
            <button className="btn-secondary modal-cancel-button mr-0" onClick={handleCloseModal}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ReplaceFileModal;
